import { Button, Input, InputRef, Space } from "antd";
import { FilterDropdownProps } from "antd/es/table/interface";
import { Search } from "lucide-react";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

export const TableFilterDropdown = ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters,
  }: FilterDropdownProps) => {

    const {t} = useTranslation();
    const inputRef = useRef<InputRef>(null);

    useEffect(() => {

      if (inputRef.current) {
        inputRef.current!.focus();
      }
    }, [inputRef]);
    return (
        <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
          <Input
            ref={inputRef}
            prefix={<Search style={{ color: "rgba(0, 0, 0, 0.25)" }} />}
            placeholder={t("searchName")}
            value={selectedKeys[0]}
            autoFocus
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
            }}
            onPressEnter={() => confirm()}
            style={{ display: "flex", marginBottom: "8px" }}
          />
          <Space>
            <Button type="primary" size="small" onClick={() => confirm()}>
              {t("search")}
            </Button>
            <Button
              size="small"
              type="dashed"
              onClick={() => {
                setSelectedKeys([""]);
                if (clearFilters !== undefined) {
                  clearFilters();
                }
                confirm();
              }}
            >
              {t("reset")}
            </Button>
          </Space>
        </div>
    )
}